export const featuredArticles = [
  {
    slug: 'chain-restaurant-kitchen',
    title: '连锁餐饮后厨随访：一份检查记录暴露的三个问题',
    channel: '社会民生',
    summary: '我们从三个月内的公开检查记录出发，对照门店自述与顾客反馈，梳理出反复出现的三个环节。',
    date: '2026-09-08',
    readCount: 48210,
    tag: '独家',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20dim%20restaurant%20kitchen%20silhouette%20behind%20frosted%20glass%2C%20deep%20charcoal%20tones%20with%20crimson%20and%20amber%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-restaurant&orientation=landscape',
  },
  {
    slug: 'smart-home-privacy',
    title: '智能家居数据流向追踪：哪些权限在悄悄运行',
    channel: '科技内幕',
    summary: '把五款常见设备的权限清单放在一起对比，我们发现了几个容易被忽略的默认开关。',
    date: '2026-09-07',
    readCount: 36125,
    tag: '深度',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20connected%20device%20nodes%20and%20dashed%20data%20lines%20over%20deep%20charcoal%20background%2C%20amber%20and%20crimson%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-smarthome&orientation=landscape',
  },
  {
    slug: 'live-commerce-price',
    title: '直播间价格套路拆解：划线价到底怎么来的',
    channel: '消费维权',
    summary: '跟踪六场直播的价格变化，还原优惠话术背后的定价逻辑，附上一份自查清单。',
    date: '2026-09-06',
    readCount: 52840,
    tag: '热点',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20price%20tag%20shape%20with%20strikethrough%20lines%20on%20deep%20charcoal%20paper%2C%20crimson%20and%20amber%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-livecommerce&orientation=landscape',
  },
  {
    slug: 'ev-parameter-check',
    title: '新能源车参数疑云：宣传口径与实测表现差在哪',
    channel: '汽车真相',
    summary: '把官方宣传页与第三方实测数据并排比对，找出续航与充电描述里常见的模糊地带。',
    date: '2026-09-05',
    readCount: 29460,
    tag: '测评',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20sleek%20car%20silhouette%20with%20gauge%20lines%20on%20deep%20charcoal%20background%2C%20amber%20and%20crimson%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-ev&orientation=landscape',
  },
  {
    slug: 'training-refund',
    title: '培训退费纪实：一份合同里被忽略的补充条款',
    channel: '教育真相',
    summary: '从一位家长的完整沟通记录出发，拆解退费流程卡在哪个环节，以及如何提前规避。',
    date: '2026-09-04',
    readCount: 21730,
    tag: '案例',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20folded%20contract%20pages%20and%20a%20stamp%20shape%20on%20deep%20charcoal%20surface%2C%20crimson%20and%20amber%20details%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-training&orientation=landscape',
  },
  {
    slug: 'oem-brand-chain',
    title: '网红品牌代工链条：同一个工厂出来的两个价格',
    channel: '财经揭密',
    summary: '顺着公开的供应商信息一路追溯，看看同类产品在不同品牌间的定价差异从何而来。',
    date: '2026-09-03',
    readCount: 34680,
    tag: '调查',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20supply%20chain%20diagram%20with%20boxes%20and%20arrows%20on%20deep%20charcoal%20background%2C%20amber%20and%20crimson%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=960&height=640&seq=baoliao-art-oem&orientation=landscape',
  },
];